import React, { useEffect } from 'react'
import styled from 'styled-components'
import { ServiceCard } from '../components'
import { serviceCards } from '../config'

const SectionWrapper = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: auto;
  padding-bottom: 140px;
  @media screen and (max-width: 1023px) {
    padding-bottom: 120px;
  }
  @media screen and (max-width: 800px) {
    padding-bottom: 100px;
  }
`
const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%;
  margin: 0 auto;
  color: var(--text);
  @media screen and (max-width: 800px) {
    width: calc(100% - 50px);
    margin: 0 25px;
  }
`
const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 68%;
  max-width: var(--max-width);
  margin: 0 auto;
  h2.service-title {
    text-align: center;
    margin-bottom: 15px;
  }
  h3.service-subtitle {
    font-size: var(--fz-lg);
    color: var(--text);
    line-height: 1.5;
    text-align: center;
    font-weight: 400;
    margin-bottom: 40px;
  }
  @media screen and (max-width: 800px) {
    width: 100%;
  }
`
const SectionGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(275px, 1fr));
  gap: 20px;
  position: relative;
  /* ANIMATION SEQUENCE */
  &.sequence {
    .article-card {
      animation-fill-mode: forwards;
      animation-duration: 0.5s;
      opacity: 0;
      transform: translateY(15px);
    }
  }
  &.sequence.start {
    .article-card {
      animation-name: fadeIn;
    }
    .article-card:nth-child(1) {
      animation-delay: 0.3s;
    }
    .article-card:nth-child(2) {
      animation-delay: 0.4s;
    }
    .article-card:nth-child(3) {
      animation-delay: 0.5s;
    }
    .article-card:nth-child(4) {
      animation-delay: 0.6s;
    }
    .article-card:nth-child(5) {
      animation-delay: 0.7s;
    }
    .article-card:nth-child(6) {
      animation-delay: 0.8s;
    }
    .article-card:nth-child(7) {
      animation-delay: 0.9s;
    }
    .article-card:nth-child(8) {
      animation-delay: 1s;
    }
    .article-card:nth-child(9) {
      animation-delay: 1.1s;
    }
    .article-card:nth-child(10) {
      animation-delay: 1.2s;
    }
    .article-card:nth-child(11) {
      animation-delay: 1.3s;
    }
    .article-card:nth-child(12) {
      animation-delay: 1.4s;
    }
    .article-card:nth-child(13) {
      animation-delay: 1.5s;
    }
    .article-card:nth-child(14) {
      animation-delay: 1.6s;
    }
    .article-card:nth-child(15) {
      animation-delay: 1.7s;
    }
    .article-card:nth-child(16) {
      animation-delay: 1.8s;
    }
    .article-card:nth-child(17) {
      animation-delay: 1.9s;
    }
    .article-card:nth-child(18) {
      animation-delay: 2s;
    }
    .article-card:nth-child(19) {
      animation-delay: 2.1s;
    }
    .article-card:nth-child(20) {
      animation-delay: 2.2s;
    }
    .article-card:nth-child(21) {
      animation-delay: 2.3s;
    }
    .article-card:nth-child(22) {
      animation-delay: 2.4s;
    }
    .article-card:nth-child(23) {
      animation-delay: 2.5s;
    }
    .article-card:nth-child(24) {
      animation-delay: 2.6s;
    }
    .article-card:nth-child(25) {
      animation-delay: 2.7s;
    }
    .article-card:nth-child(26) {
      animation-delay: 2.8s;
    }
    .article-card:nth-child(27) {
      animation-delay: 2.9s;
    }
    .article-card:nth-child(28) {
      animation-delay: 3s;
    }
    .article-card:nth-child(29) {
      animation-delay: 3.1s;
    }
    .article-card:nth-child(30) {
      animation-delay: 3.2s;
    }
    @keyframes fadeIn {
      0% {
        transform: translateY(15px);
      }
      100% {
        opacity: 1;
        transform: translateY(0px);
      }
    }
  }
`

const ServiceExpert = () => {
  useEffect(() => {
    const items = document.querySelectorAll('.sequence')
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          entry.target.classList.toggle('start', entry.isIntersecting)
          if (entry.isIntersecting) observer.unobserve(entry.target)
        })
      },
      { threshold: 0, rootMargin: '-100px' }
    )
    items.forEach(item => {
      observer.observe(item)
    })

    return () => {
      observer.disconnect()
    }
  }, [])

  return (
    <SectionWrapper>
      <SectionContainer>
        <HeaderContainer>
          <h2 className="service-title">Shopify Expert Services</h2>
          <h3 className="service-subtitle">Shopify expert services are designed to help businesses of all sizes succeed in the world of e-commerce. I offer a range of services to help businesses create and manage their online stores. I also provide ongoing support and maintenance to ensure businesses keep up with the ever-changing e-commerce landscape.</h3>
        </HeaderContainer>
        <SectionGrid className="sequence">
          {serviceCards.map(({ id, url, icon, title, desc, service }) => (
            <ServiceCard key={id} id={id} icon={icon} url={url} title={title} desc={desc} service={service} />
          ))}
        </SectionGrid>
      </SectionContainer>
    </SectionWrapper>
  )
}

export default ServiceExpert
